<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
@if (loader) {
  <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500; ">
    <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%; }">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}
<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
      <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
        <i class="pi pi-question text-5xl"></i>
      </div>
      <span class="font-bold text-2xl block mb-2 mt-4">
        {{ message.header }}
      </span>
      <p class="mb-0">{{ message.message }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button pButton
          label="Save"
          (click)="cd.accept()"
          class="w-8rem">
        </button>
        <button pButton
          label="Cancel"
          (click)="cd.reject()"
          class="p-button-outlined w-8rem ">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
<main class="main">
  <div class="container cms_main fadeInUp animated">
    <div class="inner_body">
      <div class="row_card ">
        <div class="cms_card-headings">Suplier Passenger Criteria List</div>
        <div>
          <button class="button-61" (click)="createSupplierPassengerCriteria()">Add New Criteria</button>
        </div>

      </div>
      <div class="row cms_tabel">
        <div class="col-sm-12">
          <dx-data-grid id="grid" [dataSource]="supplierPassengerCriteria" [showBorders]="true" [showRowLines]="true"
            (onContentReady)="contentReady($event)">
            <dxo-selection mode="single"></dxo-selection>
            <dxo-paging [pageSize]="100"></dxo-paging>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-pager [showPageSizeSelector]="true"
            [allowedPageSizes]="[50, 100]"></dxo-pager>
            <dxi-column [visible]="false" dataType="number" dataField="supPassMasterCriteriaId" alignment="center"></dxi-column>
            <dxi-column dataField="name" caption="Name" dataType="string" alignment="center"></dxi-column>
            <dxi-column dataField="supplier" caption="Supplier" [width]="300" dataType="string" alignment="center"></dxi-column>
            <dxi-column caption="Action" [allowSorting]="false" alignment="center"
            cellTemplate="actionCellTemplate"></dxi-column>

            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <div *dxTemplate="let data of 'actionCellTemplate'">
              <div class="card_buttons">
                <a class="card_button-editcheck" style="font-size:18px;margin-right:5px" (click)="updateCriteria(data.data.supPassMasterCriteriaId)">
                  <i class="uil uil-edit card_button-icon"></i>
                </a>
                <a class="card_button-delete" style="font-size:18px" (click)="confirmdelete(data.data)">
                  <i class="uil uil-trash-alt card_button-del"></i>
                </a>
              </div>
            </div>

          </dx-data-grid>
          <dx-popover [(target)]="popoverTarget"
            [width]="200">
            <div *dxTemplate="let data of 'content'">
              <span>{{popOverText}}</span>
            </div>
          </dx-popover>
        </div>
      </div>
    </div>
  </div>
</main>
